module.exports = __webpack_public_path__ + "img/logo.d667b793.png";